<nz-spin [nzSpinning]="loading$ | async">
  <form
    *ngIf="form"
    class="form"
    nz-form
    nzLayout="vertical"
    [formGroup]="form"
    (ngSubmit)="onSubmit()">
    <div class="drawer-form-wrapper questionnaires-form">
      <nz-form-item>
        <nz-form-label id="attachmentName-label" nzFor="attachmentName"
          >Questionnaire Attachment Name</nz-form-label
        >
        <nz-form-control [nzErrorTip]="attachmentNameErrorTpl">
          <input
            class="mr-10"
            formControlName="attachmentName"
            type="text"
            nz-input
            id="attachmentName"
            aria-labelledby="attachmentName-label"
            aria-label="Questionnaire Attachment Name"
            placeholder="Type Attachment Name" />
        </nz-form-control>
        <ng-template #attachmentNameErrorTpl>
          <span *ngIf="getControl('attachmentName')?.hasError('required')"
            >Please enter attachment name!</span
          >
          <span *ngIf="getControl('attachmentName')?.hasError('minlength')"
            >Attachment name must be at least 3 characters.</span
          >
          <span *ngIf="getControl('attachmentName')?.hasError('maxlength')"
            >Attachment name cannot exceed 100 characters.</span
          >
        </ng-template>
      </nz-form-item>
      <nz-divider />
      <ng-container *ngFor="let question of questionList; let i = index">
        <nz-form-item>
          <div class="header-with-cta">
            <div class="quetion-badge">
              <span class="badge"> {{ 'Question ' + (i + 1) }} </span>
              <h3 class="title s-18 required">
                {{ question.questionText || '' }}
              </h3>
            </div>
          </div>
          <ng-container [ngSwitch]="question.answerTypeId">
            <ng-container *ngSwitchCase="answerType.TEXTBOX">
              <nz-form-label [nzFor]="'que_' + question.id">{{
                question?.hintText
              }}</nz-form-label>
              <nz-form-control
                [nzValidateStatus]="
                  form.get('que_' + question.id)?.invalid &&
                  form.get('que_' + question.id)?.touched
                    ? 'error'
                    : ''
                "
                [nzErrorTip]="textErrorTpl">
                <input
                  [id]="'que_' + question.id"
                  [name]="'que_' + question.id"
                  type="text"
                  nz-input
                  [formControlName]="'que_' + question.id"
                  placeholder="Enter answer" />
                <ng-template #textErrorTpl>
                  <span
                    *ngIf="
                      getControl('que_' + question.id)?.hasError('required')
                    "
                    >Please provide an answer.</span
                  >
                  <div
                    *ngIf="
                      getControl('que_' + question.id)?.hasError('maxlength')
                    ">
                    Answer cannot exceed 255 characters.
                  </div>
                  <div
                    *ngIf="
                      getControl('que_' + question.id)?.hasError('pattern')
                    ">
                    Answer is invalid.
                  </div>
                </ng-template>
              </nz-form-control>
            </ng-container>

            <ng-container *ngSwitchCase="answerType.PARAGRAPH">
              <nz-form-label [nzFor]="'que_' + question.id">{{
                question?.hintText
              }}</nz-form-label>
              <nz-form-control
                [nzValidateStatus]="
                  form.get('que_' + question.id)?.invalid &&
                  form.get('que_' + question.id)?.touched
                    ? 'error'
                    : ''
                "
                [nzErrorTip]="paragraphErrorTpl">
                <textarea
                  [id]="'que_' + question.id"
                  nz-input
                  [formControlName]="'que_' + question.id"
                  placeholder="Enter detailed answer"></textarea>
                <ng-template #paragraphErrorTpl>
                  <span
                    *ngIf="
                      getControl('que_' + question.id)?.hasError('required')
                    "
                    >Please provide an answer.</span
                  >
                  <div
                    *ngIf="
                      getControl('que_' + question.id)?.hasError('maxlength')
                    ">
                    Answer cannot exceed 1000 characters.
                  </div>
                  <div
                    *ngIf="
                      getControl('que_' + question.id)?.hasError('pattern')
                    ">
                    Answer is invalid.
                  </div>
                </ng-template>
              </nz-form-control>
            </ng-container>

            <ng-container *ngSwitchCase="answerType.RADIOBUTTON">
              <nz-form-label [nzFor]="'que_' + question.id">{{
                question?.hintText
              }}</nz-form-label>
              <nz-form-control
                [nzValidateStatus]="
                  form.get('que_' + question.id)?.invalid &&
                  form.get('que_' + question.id)?.touched
                    ? 'error'
                    : ''
                "
                [nzErrorTip]="radioErrorTpl">
                <nz-radio-group
                  class="custom-radio-wrapper"
                  [id]="'que_' + question.id"
                  [formControlName]="'que_' + question.id">
                  <span
                    nz-radio
                    [nzValue]="option.id"
                    *ngFor="let option of question.options">
                    {{ option.optionValue }}
                  </span>
                </nz-radio-group>
                <ng-template #radioErrorTpl>
                  <span
                    *ngIf="
                      getControl('que_' + question.id)?.hasError('required')
                    "
                    >Please select an option.</span
                  >
                </ng-template>
              </nz-form-control>
            </ng-container>

            <ng-container *ngSwitchCase="answerType.CHECKBOX">
              <nz-form-label [nzFor]="'que_' + question.id">{{
                question?.hintText
              }}</nz-form-label>
              <nz-form-control
                class="checkbox-container"
                [nzValidateStatus]="
                  form.get('que_' + question.id)?.invalid &&
                  form.get('que_' + question.id)?.touched
                    ? 'error'
                    : ''
                "
                [nzErrorTip]="checkboxErrorTpl">
                <ng-container *ngFor="let option of question.options">
                  <span
                    nz-checkbox
                    [nzChecked]="
                      getControl('que_' + question.id)?.value?.includes(
                        option.id
                      )
                    "
                    (nzCheckedChange)="
                      onCheckboxChange('que_' + question.id, $event, option.id)
                    "
                    [nzValue]="option.id">
                    {{ option.optionValue }}
                  </span>
                </ng-container>
                <ng-template #checkboxErrorTpl>
                  <span
                    *ngIf="
                      getControl('que_' + question.id)?.hasError('required')
                    "
                    >Please select at least 1 option.</span
                  >
                </ng-template>
              </nz-form-control>
            </ng-container>

            <ng-container *ngSwitchCase="answerType.DROPDOWN">
              <nz-form-label [nzFor]="'que_' + question.id">{{
                question?.hintText
              }}</nz-form-label>
              <nz-form-control
                class="select-wrapper"
                [nzValidateStatus]="
                  form.get('que_' + question.id)?.invalid &&
                  form.get('que_' + question.id)?.touched
                    ? 'error'
                    : ''
                "
                [nzErrorTip]="selectErrorTpl">
                <nz-select
                  nzPlaceHolder="Select"
                  [id]="'que_' + question.id"
                  [formControlName]="'que_' + question.id">
                  <nz-option
                    [nzValue]="option.id"
                    [nzLabel]="option.optionValue"
                    *ngFor="let option of question.options"></nz-option>
                </nz-select>
                <ng-template #selectErrorTpl>
                  <span
                    *ngIf="
                      getControl('que_' + question.id)?.hasError('required')
                    "
                    >Please select an answer.</span
                  >
                </ng-template>
              </nz-form-control>
            </ng-container>

            <ng-container *ngSwitchCase="answerType.DATE">
              <nz-form-label [nzFor]="'que_' + question.id">{{
                question?.hintText
              }}</nz-form-label>
              <nz-form-control
                class="date-wrapper"
                [nzValidateStatus]="
                  form.get('que_' + question.id)?.invalid &&
                  form.get('que_' + question.id)?.touched
                    ? 'error'
                    : ''
                "
                [nzErrorTip]="dateErrorTpl">
                <nz-date-picker
                  nzPlaceHolder="Select date"
                  nzFormat="MM/dd/yyyy"
                  [id]="'que_' + question.id"
                  [formControlName]="'que_' + question.id"
                  (ngModelChange)="
                    onDateChange($event, question.id)
                  "></nz-date-picker>
                <ng-template #dateErrorTpl>
                  <span
                    *ngIf="
                      getControl('que_' + question.id)?.hasError('required')
                    "
                    >Please select date.</span
                  >
                </ng-template>
              </nz-form-control>
            </ng-container>

            <ng-container *ngSwitchCase="answerType.TIME">
              <nz-form-label [nzFor]="'que_' + question.id">{{
                question?.hintText
              }}</nz-form-label>
              <nz-form-control
                class="time-wrapper"
                [nzValidateStatus]="
                  form.get('que_' + question.id)?.invalid &&
                  form.get('que_' + question.id)?.touched
                    ? 'error'
                    : ''
                "
                [nzErrorTip]="timeErrorTpl">
                <nz-time-picker
                  nzPlaceHolder="Select time"
                  nzUse12Hours
                  nzFormat="h:mm a"
                  [id]="'que_' + question.id"
                  [formControlName]="'que_' + question.id"></nz-time-picker>
                <ng-template #timeErrorTpl>
                  <span
                    *ngIf="
                      getControl('que_' + question.id)?.hasError('required')
                    "
                    >Please select time.</span
                  >
                </ng-template>
              </nz-form-control>
            </ng-container>

            <ng-container *ngSwitchCase="answerType.LINEARSCALE">
              <nz-form-label>{{ question?.hintText }}</nz-form-label>
              <nz-form-control
                [nzValidateStatus]="
                  form.get('que_' + question.id)?.invalid &&
                  form.get('que_' + question.id)?.touched
                    ? 'error'
                    : ''
                "
                [nzErrorTip]="linearScaleErrorTpl">
                <div class="rating-wrapper">
                  <span class="rating-label">{{
                    question?.linearScale?.minLabel || 'Min'
                  }}</span>
                  <nz-radio-group
                    [id]="'que_' + question.id"
                    [formControlName]="'que_' + question.id"
                    class="rating-options">
                    <span
                      nz-radio
                      [nzValue]="option"
                      *ngFor="
                        let option of getLinearOptions(question.linearScale)
                      ">
                      {{ option }}
                    </span>
                  </nz-radio-group>
                  <span class="rating-label">{{
                    question?.linearScale?.maxLabel || 'Max'
                  }}</span>
                </div>
                <ng-template #linearScaleErrorTpl>
                  <span
                    *ngIf="
                      getControl('que_' + question.id)?.hasError('required')
                    "
                    >Please select an answer.</span
                  >
                </ng-template>
              </nz-form-control>
            </ng-container>

            <ng-container *ngSwitchCase="answerType.FILEUPLOAD">
              <nz-form-label>{{ question?.hintText }}</nz-form-label>
              <nz-form-control
                [nzValidateStatus]="
                  form.get('que_' + question.id)?.invalid &&
                  form.get('que_' + question.id)?.touched
                    ? 'error'
                    : ''
                "
                [nzErrorTip]="fileUploadErrorTpl">
                <nz-upload
                  [nzFileList]="form.controls['que_' + question.id].value"
                  [nzBeforeUpload]="getBeforeUploadFn(question.id)"
                  [nzRemove]="getRemoveFileFn(question.id)"
                  [nzIconRender]="iconTemplate"
                  [nzPreview]="handlePreview"
                  nzListType="picture"
                  [nzShowUploadList]="{
                    showRemoveIcon: true,
                    showPreviewIcon: false,
                    showDownloadIcon: false,
                  }"
                  nzDrop
                  [nzMultiple]="true"
                  class="file-upload">
                  <button nz-button type="button">
                    <div class="upload-icon">
                      <svg-icon
                        [title]="'Upload file'"
                        src="/assets/icon/icon-upload.svg"
                        class="icon s-12"
                        aria-label="Upload"></svg-icon>
                    </div>
                    <div class="text-wrapper">
                      <p class="text s-14 fw-600 green">
                        Click to upload
                        <span class="text s-14 fw-400">or drag and drop</span>
                      </p>
                      <p class="text s-12 fw-400">
                        Supported formats: PDF, Office, Media & Images
                      </p>
                    </div>
                  </button>
                </nz-upload>
                <ng-template #fileUploadErrorTpl>
                  <span
                    *ngIf="
                      getControl('que_' + question.id)?.hasError('required')
                    "
                    >Please upload at least one file.</span
                  >
                  <ng-container
                    *ngIf="
                      getControl('que_' + question.id)?.hasError('maxSize')
                    ">
                    File size cannot exceed 5MB
                  </ng-container>
                  <ng-container
                    *ngIf="
                      getControl('que_' + question.id)?.hasError('invalidType')
                    ">
                    Invalid file type. Supported formats: PDF, DOC, DOCX, XLS,
                    XLSX, PPT, PPTX, MP3, WAV, M4A, MP4, M4V, TIF, TIFF
                  </ng-container>
                </ng-template>
              </nz-form-control>
            </ng-container>
          </ng-container>
        </nz-form-item>
        <nz-divider />
      </ng-container>
    </div>

    <div class="display-flex justify-content-between drawer-footer">
      <button
        type="button"
        nz-button
        nzType="default"
        type="button"
        (click)="closeDrawer()">
        Cancel
      </button>

      <ng-container>
        <button
          type="button"
          nz-button
          nzType="primary"
          type="submit"
          [disabled]="form.invalid">
          {{ 'Submit' }}
        </button>
      </ng-container>
    </div>
  </form>

  <ng-template #ErrorTpl let-control>
    <span *ngIf="control.hasError('required')">Please provide an answer.</span>
  </ng-template>

  <ng-template #iconTemplate let-file>
    <svg-icon
      src="/assets/icon/icon-report-green.svg"
      class="icon s-12"
      aria-label="Report Green"></svg-icon>
  </ng-template>
</nz-spin>
